import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import OpenTrips from './OpenTrips';
import CompleteTrips from './CompleteTrips';

const TripsTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const hash = location.hash;
    if (hash === '#open' || hash === '') {
      setTabValue(0);
    } else if (hash === '#closed') {
      setTabValue(1);
    }
  }, [location.hash]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    const hashMap = ['#open', '#closed'];
    navigate(`/open_trips${hashMap[newValue]}`, { replace: true });
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case 0:
        return <OpenTrips />;
      case 1:
        return <CompleteTrips />;
      default:
        return <OpenTrips />;
    }
  };

  return (
    <>
      <Box className="page-container">
          <Box className="paper-style">
            <Box sx={{ px: 2, py: 1.2 }}>
              
            <Tabs 
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              className="common-tabs"
            >
              <Tab label="Open Trips" />
              <Tab label="Closed Trips" />
            </Tabs>
            </Box>
            <Box>
            {renderTabContent()}
          </Box>
          </Box>
        </Box>
    </>
  );
};

export default TripsTabs;

